import { render } from "./NotificationSymbol.vue?vue&type=template&id=ddf531da&scoped=true"
import script from "./NotificationSymbol.vue?vue&type=script&lang=js"
export * from "./NotificationSymbol.vue?vue&type=script&lang=js"

import "./NotificationSymbol.vue?vue&type=style&index=0&id=ddf531da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf531da"],['__file',"src/components/NotificationSymbol.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddf531da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddf531da', __exports__)) {
    api.reload('ddf531da', __exports__)
  }
  
  module.hot.accept("./NotificationSymbol.vue?vue&type=template&id=ddf531da&scoped=true", () => {
    api.rerender('ddf531da', render)
  })

}


export default __exports__